<template>
  <div class="barbearia-page">
    <!-- HERO SECTION -->
    <header class="hero">
        <div class="logo">
            <img src="@/assets/landpages/barbearia/images/logo.png" alt="Logo Horabela">
        </div>

        <div class="hero-content">
            <h1>Sua barbearia pode estar perdendo dinheiro todos os dias…</h1>

            <p>
                Comissão calculada no olho, serviços que não são registrados,
                caixa que nunca fecha. O Horabela organiza tudo em um só lugar.
            </p>

            <ul class="hero-benefits">
                <li>✔ Comissão automática por barbeiro</li>
                <li>✔ Controle total do faturamento</li>
                <li>✔ Relatórios claros e em tempo real</li>
                <li>✔ Agenda profissional online 24h</li>
            </ul>

            <a href="https://app.horabela.com.br/registro" class="cta" id="cta_hero_barbearia">
                Quero parar de perder dinheiro agora
            </a>

            <p class="trial-info">
                Teste grátis por 30 dias — sem cartão e sem compromisso
            </p>
        </div>

        <div class="hero-media">
            <img src="@/assets/landpages/barbearia/images/dashboard.png" alt="Dashboard Horabela">
        </div>
    </header>

    <!-- MINI CTA -->
    <div class="mini-cta">
        <h3>Criado junto com donos de barbearia para resolver problemas reais do dia a dia</h3>
        <a href="https://app.horabela.com.br/registro" class="cta" style="background: #FFF; color: #FF7F50;">Quero fazer parte</a>
    </div>

    <!-- BENEFÍCIOS -->
    <section class="benefits">
        <h2>Por que barbearias estão escolhendo o Horabela?</h2>
        <ul>
            <li>✅ Calculo automático de comissão</li>
            <li>✅ Registrar os serviços leva poucos segundos</li>
            <li>✅ Registre as formas de recebimento da barbearia</li>
            <li>✅ Histórico completo de cada cliente</li>
            <li>✅ Relatórios fáceis de entender</li>
            <li>✅ Controle de produtos e estoque</li>
            <li>✅ Painel simples informando quanto entrou no dia, semana e mês</li>
        </ul>

        <a href="https://app.horabela.com.br/registro" class="cta cta-center" id="cta_beneficios_barbearia">Quero organizar minha barbearia</a>
    </section>

    <!-- PARA QUEM É -->
    <section class="for-who">
        <h2>Para quem o Horabela foi feito?</h2>
        <ul>
            <li>✅ Donos de barbearia que querem parar de perder dinheiro</li>
            <li>✅ Profissionais que querem comissões certas, sem discussão</li>
            <li>✅ Barbearias que querem crescer com organização e controle</li>
        </ul>

        <a href="https://app.horabela.com.br/registro" class="cta cta-center">Quero testar agora</a>
    </section>

    <!-- ANTES E DEPOIS -->
    <section class="before-after">
        <h2>Antes e Depois do Horabela</h2>

        <div class="ba-grid">
            <div class="before">
                <h3>Antes</h3>
                <ul>
                    <li>❌ Comissão calculada no olho</li>
                    <li>❌ Serviços que o barbeiro faz e ninguém registra</li>
                    <li>❌ No fim do dia ninguém sabe quanto entrou</li>
                    <li>❌ Discussões por valores</li>
                    <li>❌ Nenhum relatório claro</li>
                </ul>
            </div>

            <div class="after">
                <h3>Depois</h3>
                <ul>
                    <li>✅ Calculo automático de comissão</li>
                    <li>✅ Registro rápido e sem erros</li>
                    <li>✅ Caixa organizado e claro</li>
                    <li>✅ Transparência total para todos</li>
                    <li>✅ Relatórios simples e úteis</li>
                </ul>
            </div>
        </div>

        <a href="https://app.horabela.com.br/registro" class="cta cta-center">Quero esse resultado</a>
    </section>

    <!-- STORYTELLING -->
    <section class="story">
        <h2>O problema real das barbearias</h2>
        <p>A verdade é que muita barbearia perde dinheiro todo dia sem perceber, como por exemplo serviço que não é registrado, comissão calculada errado, produto que some do estoque. Isso vira um rombo no fim do mês.</p>

        <h3>A solução: Comanda Inteligente Horabela</h3>
        <p>Comissões automáticas, total calculado na hora, histórico completo e relatórios simples de entender.</p>

        <div class="story-media">
            <img src="@/assets/landpages/barbearia/images/comanda.png" alt="Comanda inteligente Horabela">
        </div>

        <a href="https://app.horabela.com.br/registro" class="cta cta-center">Quero parar de perder dinheiro</a>
    </section>

    <!-- PROVA SOCIAL -->
    <section class="social-proof">
        <h2>Barbearias que já sentiram a diferença</h2>

        <div class="testimonials">
            <blockquote>
                "Comecei a registrar tudo certinho e meu lucro subiu 15%."
                <span>— Rei do Corte</span>
            </blockquote>

            <blockquote>
                "Eu esquecia de cobrar vários serviços. Agora não passa nada."
                <span>— Carlos Barber</span>
            </blockquote>

            <blockquote>
                "Comissão sempre dava confusão. Agora é tudo automático."
                <span>— Barbearia do Junior</span>
            </blockquote>
        </div>

        <a href="https://app.horabela.com.br/registro" class="cta cta-center">Quero ter esse resultado</a>
    </section>

    <!-- COMO FUNCIONA -->
    <section class="how-it-works">
        <h2>Como funciona na prática</h2>

        <iframe width="100%" height="315" src="https://www.youtube.com/embed/lEKU45wpMCo?si=jLJd_GzEv0d6m4UO" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>

        <ol>
            <li>Coloque os preços e os barbeiros</li>
            <li>Se quiser, ative o agendamento pelo celular</li>
            <li>Veja quanto entrou no dia e quanto cada barbeiro fez</li>
            <li>Cresça com organização e clareza</li>
        </ol>

        <a href="https://app.horabela.com.br/registro" class="cta cta-center">Quero ver funcionando</a>
    </section>

    <!-- FAQ -->
    <section class="faq">
        <h2>Perguntas Frequentes</h2>

        <div class="faq-item">
            <button class="faq-question">É difícil de usar?</button>
            <div class="faq-answer">
                <p>Nada disso. O sistema é simples e qualquer pessoa aprende em poucos minutos.</p>
            </div>
        </div>

        <div class="faq-item">
            <button class="faq-question">Preciso colocar cartão para testar?</button>
            <div class="faq-answer">
                <p>Não precisa. Você testa grátis sem colocar cartão e sem compromisso.</p>
            </div>
        </div>

        <div class="faq-item">
            <button class="faq-question">Funciona no celular?</button>
            <div class="faq-answer">
                <p>Sim. Funciona no celular, tablet e computador.</p>
            </div>
        </div>

        <div class="faq-item">
            <button class="faq-question">O cálculo de comissão é automático?</button>
            <div class="faq-answer">
                <p>Sim. O sistema calcula tudo sozinho, por serviço e por barbeiro.</p>
            </div>
        </div>

        <div class="faq-item">
            <button class="faq-question">E se meus barbeiros não quiserem usar?</button>
            <div class="faq-answer">
                <p>Eles aprendem rápido e gostam porque tudo fica claro e sem discussão.</p>
            </div>
        </div>

        <div class="faq-item">
            <button class="faq-question">Posso cancelar quando quiser?</button>
            <div class="faq-answer">
                <p>Pode sim. Não tem fidelidade e você cancela quando quiser.</p>
            </div>
        </div>

        <a href="https://app.horabela.com.br/registro" class="cta cta-center" id="cta_faq_barbearia">Quero tirar minhas dúvidas com um especialista</a>
    </section>

    <!-- OFERTA -->
    <section class="offer">
        <h2>Oferta Especial para Barbearias</h2>
        <p class="trial-info">Configuração gratuita + treinamento + suporte prioritário</p>

        <div class="timer">
            <span>Oferta válida por tempo limitado</span>
        </div>

        <a href="https://app.horabela.com.br/registro" class="cta">Quero modernizar minha barbearia</a>
    </section>

    <!-- FOOTER -->
    <footer>
        <p>Horabela © Todos os direitos reservados</p>
        <!-- <a href="https://app.horabela.com.br/registro">Política de Privacidade</a> |
        <a href="https://app.horabela.com.br/registro">Termos de Uso</a> -->
    </footer>
  </div>
</template>

<script>
export default {
  name: 'Barbearia',
  data() {
    return {
      // Suas variáveis de dados aqui
    }
  },
  mounted() {
    // FAQ Toggle
    const questions = document.querySelectorAll('.faq-question');
    questions.forEach(q => {
        q.addEventListener('click', () => {
            const answer = q.nextElementSibling;
            answer.classList.toggle('open');
            q.classList.toggle('active');
        });
    });
  },
  methods: {
    // Seus métodos aqui
  }
}
</script>

<style scoped>
@import '@/assets/landpages/barbearia/css/styles.css';
</style>

